import { IHistoryStep, ILanding } from "src/modules/pe-landing-module/data/interfaces";
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store";
import localUpdate from "./localUpdate";
import updateLandingData from "./updateLandingData";

export default function updateHistory ( step: IHistoryStep, currentLanding: ILanding, isForce?: boolean, callBack?: () => void ) { 
    const history: IHistoryStep[]       = useLandingStore.getState().history
    const currentHistoryStep: number = useLandingStore.getState().currentHistoryStep

    const newVal: Partial<ILandingStore> = {  
        currentLanding,
        history: [ step, ...history, ],  
        needUpdate: true ,  
    }
    if( currentHistoryStep > 0 ) {
        newVal.currentHistoryStep = 0
        newVal.history = [ step ]
    }
    else {
        newVal.history = [ step, ...useLandingStore.getState().history ]
    }  
    localUpdate( newVal, "update history:" )
    if(isForce) {
        updateLandingData( callBack )
    }
}